import React from 'react';
import { ComingSoon } from './pages/ComingSoon';
export function App() {
  return <ComingSoon data-id="element-0" />;
}